export default __webpack_public_path__ + "static/media/image1.ba4e59f0.jpeg";